// @flow
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { AppContext } from "../../../../context/AppContext";
import { getChartScalingConfig } from "../../../../helpers/helpers";

const chartHeight = 300;
const maxTickHeightPX = 25;

// simple line chart
const BarChart = (props) => {

  const { theme } = React.useContext(AppContext);
  const [colors, setColors] = useState(props.colors);
  const [title, setTitle] = useState(props.title);
  const [categories, setCategories] = useState(props.xAxis);
  const [dataArray, setDataArray] = useState(props.dataArray);
  const [data, setData] = useState(props.data);
  const [width, setWidth] = useState(props.width);

  useEffect(() => {
    setColors(props.colors);
    setTitle(props.title);
    setWidth(props.width);
    setCategories(props.xAxis);
    setData(props.data);
    setDataArray(props.dataArray);
  }, [props.colors, props.title, props.data, props.xAxis, props.width, props.max, props.min]);

  const yScalingConfig = getChartScalingConfig(dataArray, chartHeight, maxTickHeightPX, true);

  const options = {

    plotOptions: {
    bar: {
      dataLabels: {
        enabled: true,
        position:"top"
      }
    }
  },

    chart: {
      height: "auto",
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      type: "bar",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: colors,

    tooltip: {
      theme: theme === "light-theme" ? "dark" : "light",
      x: { show: true },
      shared: true,
      intersect: false
    },
    dataLabels: {
      enabled: true,
      textAnchor: "top",
      offsetY: -32,
      offsetX: -8,
      background: {
        enabled: true,
        foreColor: '#000',
        borderRadius: 2,
        padding: 4,
        opacity: 0.9,
        borderWidth: 1,
        borderColor: '#000'
      }
    },
    stroke: {
      width: [3, 3],
      curve: "smooth",
    },
    title: {
      text: title,
      align: "left",
      style: {
        fontSize: "14px",
        color: "transparent",
      },
    },
    grid: {
      show: true,
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 1,
      },
      borderColor: "#f1f3fa10",
    },
    markers: {
      // style: "inverted",
      size: 1,
    },
    xaxis: {
      categories: categories,
      type: "category",
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,

        color: "#78909C20",
      },
      labels: {
        style: {
          colors: "#10939f",
        },
      },
    },

    yaxis: {
      ...yScalingConfig,
      axisBorder: {
        show: false,

        color: "#78909C20",
      },
      labels: {
        formatter: function (val) {
          let y = val ? val.toFixed(0) : 0;

          return y;
        },
        minWidth: 20,
        maxWidth: 160,
        style: {
          colors: ["#10939f"],
        },
      },
    },
    legend: {
      position: "top",
      showForSingleSeries: true,
      horizontalAlign: "right",
      floating: true,
      offsetY: -25,
      offsetX: -5,
      labels: {
        useSeriesColors: true,
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
          },
        },
      },
    ],
  };

  return (
    <Chart
      options={options}
      series={data}
      type="bar"
      width={"100%"}
      height={chartHeight}
      className="apex-charts"
    />
  );
};

export default BarChart;
